// Slide media mobile
function mmSlideProduct() {
	var splideElemMain = document.querySelector('#main-slider');
	var bar = splideElemMain.querySelector('.my-slider-progress-bar');

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: 'loop',
			pagination: true,
			arrows: false,
			perPage: 1,
			destroy: true,
			breakpoints: {
				992: {
					padding: {
						right: 0,
					},
					destroy: false,
				},
			},
		});

		main.on('mounted move', function () {
			var end = main.Components.Controller.getEnd() + 1;
			var rate = Math.min((main.index + 1) / end, 1);
			bar.style.width = String(100 * rate) + '%';
		});

		main.mount();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	mmSlideProduct();
});

// Gestion du texte mannequin
if (window.innerWidth > 768) {
	const section = document.querySelector('.mm-product-medias');
	const stickyDiv = document.getElementById('stickyDiv');

	window.addEventListener('scroll', function () {
		const sectionRect = section.getBoundingClientRect();
		const lastSplideSlide = section.querySelector('.splide__slide:last-of-type');

		if (lastSplideSlide && lastSplideSlide.getBoundingClientRect().bottom <= window.innerHeight) {
			stickyDiv.style.display = 'none';
		} else {
			stickyDiv.style.display = 'block';
		}
	});
}

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll('.mm-product-form-dropdown');
allDropdown.forEach((content) => {
	content.addEventListener('click', function () {
		checkDropdown(content, false);
	});
	checkDropdown(content, true);
});

function checkDropdown(dropdown, load) {
	if (load && dropdown.classList.contains('active')) {
		const content = dropdown.nextElementSibling;
		content.style.height = content.scrollHeight + 'px';
	} else if (!load) {
		dropdown.classList.toggle('active');
		const content = dropdown.nextElementSibling;
		if (content.style.height) {
			content.style.height = null;
		} else {
			content.style.height = content.scrollHeight + 'px';
		}
		allDropdown.forEach((elem) => {
			if (elem != dropdown) {
				elem.classList.remove('active');
				elem.nextElementSibling.style.height = null;
			}
		});
	}
}

// VARIANT SELECTOR
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest('.mm-main-product-grid');
		this.addEventListener('change', this.onVariantChange.bind(this));
		this.variantData = this.getVariantJSON();
		this.updateOptionsStocks();
	}

	onVariantChange() {
		// console.log('changed');
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			this.variantFetch();
			this.updateOptionsStocks();
			this.refreshSizeSelector();
			this.refreshStockInfo();
			this.refreshReassurances();
		}
	}

	refreshSizeSelector() {
		const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
	
		if (this.cached[variantUrl]) {
			this.updateElementsOuter('.mm-mpf-CTA-mobile-selector-size-container', this.cached[variantUrl]);
			return;
		}
	
		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				this.updateElementsOuter('.mm-mpf-CTA-mobile-selector-size-container', html);
			})
			.catch((e) => {
				console.error('Erreur lors de la mise à jour du sélecteur de taille:', e);
			});
	}


	refreshReassurances() {
		if (!this.currentVariant || !this.currentVariant.id) {
			return;
		}
	
		const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
	
		if (this.cached[variantUrl]) {
			// Mise à jour spécifique pour mobile et desktop
			this.updateElementsOuter('.mm-mobile-992 .mm-main-product-reassurance', this.cached[variantUrl]);
			this.updateElementsOuter('.mm-desktop-992 .mm-main-product-reassurance', this.cached[variantUrl]);
			this.updateElementsOuter('.mm-CTA-reassurances-container', this.cached[variantUrl]);
			return;
		}
	
		fetch(variantUrl)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.text();
			})
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				// Mise à jour spécifique pour mobile et desktop
				this.updateElementsOuter('.mm-mobile-992 .mm-main-product-reassurance', html);
				this.updateElementsOuter('.mm-desktop-992 .mm-main-product-reassurance', html);
				this.updateElementsOuter('.mm-CTA-reassurances-container', html);
			})
			.catch((e) => {
				console.error('Erreur lors de la mise à jour des réassurances:', e);
				console.error('URL utilisée:', variantUrl);
			});
	}

	refreshStockInfo() {
		const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
	
		if (this.cached[variantUrl]) {
			this.updateElementsOuter('.mm-text-small-mobile.mm-black-50.mm-text-initial', this.cached[variantUrl]);
			return;
		}
	
		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				this.updateElementsOuter('.mm-text-small-mobile.mm-black-50.mm-text-initial', html);
			})
			.catch((e) => {
				console.error('Erreur lors de la mise à jour des informations de stock:', e);
			});
	}

	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll('.mm-product-variant-checkbox:checked'), (checkbox) => checkbox.value);
	}

	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	disableAddToCartButton(button) {
		button.disabled = true;
		button.removeEventListener('click', mmAddProductToCart);
	}

	hasVariantInURL() {
		return window.location.search.includes('variant=');
	}

	updateURL() {
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		this.updateElementsOuter('#mmProductFormSelectedVariantId', html);
		this.updateElementsOuter('.mm-main-product-button-container', html);
		this.updateElementsOuter('.mm-product-form-price-container', html);
		this.updateElementsOuter('.mm-find-in-store-shops', html);
		this.rebindAddToCartEvent();
	}

	rebindAddToCartEvent() {
		const buttons = this.container.querySelectorAll('.mm-main-product-button-container');
		buttons.forEach((button) => {
			if (this.currentVariant && this.currentVariant.available) {
				button.disabled = false;
				button.onclick = () => {
					mmAddProductToCart(
						document.querySelector('#mmProductFormSelectedVariantId').value,
						1,
						{ openCart: true }
					);
				};
			} else {
				button.disabled = true;
				button.onclick = null;
			}
		});
	}

    updateElementsOuter(selector, html) {
		const destinations = this.container.querySelectorAll(selector);
		const sources = html.querySelectorAll(selector);

		//   console.log('destinations', destinations)

		destinations.forEach((destination, index) => {
			const source = sources[index];
			if (source) {
				destination.outerHTML = source.outerHTML;
			}
		});
    }

	updateOptionsStocks() {
		const JSONoptions = this.variantData;
		const variantSelectors = document.querySelectorAll('.variant-selector');

		variantSelectors.forEach((variantSelector) => {
			const optionsValues = variantSelector.querySelectorAll('.mm-product-form-variant-values');

			optionsValues.forEach((optionValues, index) => {
				let mainIndex = index;
				let optionIndex = index;
				let options = optionValues.querySelectorAll('input');

				options.forEach((option) => {
					let currentOptionTested = option;
					let valuesToTest = [];
					valuesToTest.push(option.value);
					optionsValues.forEach((optionValues, index) => {
						if (index != optionIndex) {
							let options = optionValues.querySelectorAll('input');
							options.forEach((option) => {
								if (option.checked) {
									valuesToTest.push(option.value);
								}
							});
						}
						if (index == optionsValues.length - 1) {
							if (checkIfAvailable(JSONoptions, valuesToTest) == false) {
								currentOptionTested.classList.add('mm-disabled');
							} else {
								currentOptionTested.classList.remove('mm-disabled');
							}
						}
					});
				});
			});
		});
	}
}

customElements.define('variant-selector', VariantSelector);

function checkIfAvailable(JSONoptions, valuesToTest) {
	//console.log('valuesToTest :', valuesToTest);
	const valuesToTestSorted = valuesToTest.slice().sort();
	//console.log('valuesToTestSorted :', valuesToTestSorted);

	for (let option of JSONoptions) {
		let optionsSorted = option.options.slice().sort();
		//console.log('optionsSorted :', optionsSorted);

		if (optionsSorted.every((val, index) => val === valuesToTestSorted[index])) {
			return option.available;
		}
	}

	return false;
}

function mmSyncOtherVariantSelector(clickedElem) {
	const value = clickedElem.value;
	//console.log('clickedElem', clickedElem)
	const inputsToCheck = document.querySelectorAll(`.mm-product-variant-checkbox[value="${value}"]`);

	inputsToCheck.forEach(function (inputToCheck) {
		//console.log('this Input', inputToCheck)
		inputToCheck.checked = true;

		var event = new Event('change');
		let variantSelector = inputToCheck.closest('variant-selector');
		if (variantSelector) {
			inputToCheck.closest('variant-selector').dispatchEvent(event);
		}
	});
}

function setUpButtons() {
	const url = new URL(window.location.href);
	const buttons = document.querySelectorAll('.mm-main-product-button-container');
	const checkboxes = document.querySelectorAll('.mm-product-variant-checkbox');

	if (url.searchParams.has('variant')) {
		const variantCode = url.searchParams.get('variant');
		console.log('Le code variant est:', variantCode);
		const jsonDataElement = document.querySelector('variant-selector script[type="application/json"]');
		const data = JSON.parse(jsonDataElement.textContent);

		console.log('data', data);

		const options = findOptionsById(data, variantCode);
		if (options) {
			console.log('Options trouvées:', options);
			options.forEach(function (option) {
				document.querySelectorAll(`.mm-product-variant-checkbox[value="${option}"]`).forEach(function (checkbox) {
					checkbox.checked = true;
				});
			});
		} else {
			console.log('Aucun élément trouvé avec cet ID.');
		}
	} else {
		console.log("L'URL ne contient pas de paramètre 'variant'.");
		buttons.forEach(function (button) {
			button.innerText = 'Sélectionner une taille';
			button.disabled = true;
		});
		checkboxes.forEach(function (checkbox) {
			checkbox.checked = false;
		});
	}
}

function findOptionsById(data, idToFind) {
	// On parcourt le tableau de données
	for (let item of data) {
		if (item.id === parseInt(idToFind)) {
			return item.options; // Retourne les options quand l'ID correspond
		}
	}
	return null; // Retourne null si aucun élément correspondant n'est trouvé
}

document.addEventListener('DOMContentLoaded', (event) => {
	//setUpButtons();
});

// SIZE CHART
function mmOpenSC(event) {
	const clickedElement = event.target;
	const sizeChartWrapper = document.querySelector('.mm-size-chart-wrapper');
	const filter = document.querySelector('.mm-size-chart-filter');
	
	sizeChartWrapper.classList.remove('mm-hidden');
	
	// Ajouter le filtre uniquement si on clique sur mm-product-form-main-size-guide
	if (clickedElement.classList.contains('mm-product-form-main-size-guide')) {
		filter.classList.add('active');
	}
	
	if (window.innerWidth < 768) {
		document.querySelector('.mm-section-header').classList.add('mm-none');
	}
}

function mmCloseSC() {
	const sizeChartWrapper = document.querySelector('.mm-size-chart-wrapper');
	const filter = document.querySelector('.mm-size-chart-filter');
	
	sizeChartWrapper.classList.add('mm-hidden');
	filter.classList.remove('active'); // On retire toujours la classe active
	
	if (window.innerWidth < 768) {
		document.querySelector('.mm-section-header').classList.remove('mm-none');
	}
}

function afficherTableauMesures() {
    const tableauMesures = document.querySelectorAll('.mm-size-chart-measurements');
    const tableauConversions = document.querySelectorAll('.mm-size-chart-internationnals-conversions');
    const tableauMesuresTitle = document.querySelector('.mm-size-chart-measurements-title');
    const tableauConversionsTitle = document.querySelector('.mm-size-chart-internationnal-title');

    // Afficher les tableaux de mesures et cacher les tableaux de conversions
    tableauMesures.forEach(tableau => tableau.style.display = 'block');
    tableauConversions.forEach(tableau => tableau.style.display = 'none');

    // Mettre à jour le style des titres
    tableauMesuresTitle.classList.add('mm-underline');
    tableauMesuresTitle.classList.remove('mm-black-20');
    tableauConversionsTitle.classList.add('mm-black-20');
    tableauConversionsTitle.classList.remove('mm-underline');
}

function afficherTableauConversions() {
    const tableauMesures = document.querySelectorAll('.mm-size-chart-measurements');
    const tableauConversions = document.querySelectorAll('.mm-size-chart-internationnals-conversions');
    const tableauMesuresTitle = document.querySelector('.mm-size-chart-measurements-title');
    const tableauConversionsTitle = document.querySelector('.mm-size-chart-internationnal-title');

    // Afficher les tableaux de conversions et cacher les tableaux de mesures
    tableauConversions.forEach(tableau => tableau.style.display = 'block');
    tableauMesures.forEach(tableau => tableau.style.display = 'none');

    // Mettre à jour le style des titres
    tableauConversionsTitle.classList.add('mm-underline');
    tableauConversionsTitle.classList.remove('mm-black-20');
    tableauMesuresTitle.classList.add('mm-black-20');
    tableauMesuresTitle.classList.remove('mm-underline');
}

// Ajouter les écouteurs d'événements sur les titres
document.querySelector('.mm-size-chart-measurements-title').addEventListener('click', afficherTableauMesures);
document.querySelector('.mm-size-chart-internationnal-title').addEventListener('click', afficherTableauConversions);



// DROPDOWN
document.addEventListener('DOMContentLoaded', function () {
    var dropdownDescriptions = document.querySelectorAll('.mm-product-form-description-dropdown');

    for (var q = 0; q < dropdownDescriptions.length; q++) {
        dropdownDescriptions[q].addEventListener('click', toggleDropdown);

        // Ouvre spécifiquement l'élément mm-product-form-description-dropdown-5 par défaut en mobile
        if (dropdownDescriptions[q].classList.contains('mm-open-dropdown') &&
            window.innerWidth <= 768) { // Assurez-vous que la largeur est pour un mobile
            dropdownDescriptions[q].classList.add('active');
            const content = dropdownDescriptions[q].nextElementSibling;
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }
});

function toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    this.classList.toggle('active');

    const content = this.nextElementSibling;

    if (content.style.maxHeight) {
        content.style.maxHeight = null;
    } else {
        content.style.maxHeight = content.scrollHeight + 'px';
    }
}

if (window.innerWidth > 768) {
	// PRODUCT FORM DESCRIPTION
	function mmOpenD(index) {
		var dropdown = document.querySelector('.mm-product-form-description-dropdown-' + index);
		document.querySelector('.mm-product-form-description-wrapper').classList.remove('mm-hidden');

		if (dropdown) {
			dropdown.classList.add('active');
			var content = dropdown.nextElementSibling;
			content.style.maxHeight = content.scrollHeight + 'px';
		}
	}

	function mmCloseD() {
		var dropdowns = document.querySelectorAll('.mm-product-form-description-dropdown');

		dropdowns.forEach(function (dropdown) {
			dropdown.classList.remove('active');
			var content = dropdown.nextElementSibling;
			content.style.maxHeight = null;
		});

		document.querySelector('.mm-product-form-description-wrapper').classList.add('mm-hidden');
	}
}

// FIND IN STORE POPUP HANDLE
function mmOpenFindInStore() {
	var productForm = document.querySelector('.mm-product-form');
	productForm.style.zIndex = "16";
	document.querySelector('html').classList.add('stop-scrolling');
	document.querySelector('.mm-find-in-store-popup-wrapper-filter').classList.remove('mm-hidden');
}

function mmCloseFindInStore() {
	var productForm = document.querySelector('.mm-product-form');
	document.querySelector('html').classList.remove('stop-scrolling');
	document.querySelector('.mm-find-in-store-popup-wrapper-filter').classList.add('mm-hidden');
	setTimeout(function() {
		productForm.style.zIndex = "0";
	}, 500);
}

// ZOOM IMAGE
if (window.innerWidth > 768) {
	// Fonction pour ouvrir le zoom
	function toggleZoom() {
		let zoomedDiv = document.getElementById('mmZoomedDiv');
		if (zoomedDiv.style.display === 'none') {
			zoomedDiv.style.display = 'block';
			zoomedDiv.style.cursor = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cg clip-path='url(%23clip0_20_1460)'%3E%3Cpath d='M18.3633 5.63525L5.63536 18.3632' stroke='%23808080' stroke-width='1.5' stroke-miterlimit='10'/%3E%3Cpath d='M5.63672 5.63525L18.3646 18.3632' stroke='%23808080' stroke-width='1.5' stroke-miterlimit='10'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_20_1460'%3E%3Crect width='24' height='24' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E\"), auto";
			zoomedDiv.addEventListener('click', function () {
				zoomedDiv.style.display = 'none';
			});
		} else {
			zoomedDiv.style.display = 'none';
			zoomedDiv.style.cursor = 'auto';
		}
	}

	// Fonction pour fermer le zoom
	function toggleZoomClose() {
		let zoomedDiv = document.getElementById('mmZoomedDiv');
		zoomedDiv.style.display = 'none';
		zoomedDiv.style.cursor = 'auto';
	}

	// Animation sur l'image zoomée
	document.addEventListener('DOMContentLoaded', function () {
		let zoomedDiv = document.getElementById('mmZoomedDiv');

		if (window.innerWidth > 1023) {
			const pos = { x: 0, y: 0 };
			const mouse = { x: pos.x, y: pos.y };
			let thumbWidth = window.innerWidth;
			let thumbHeight = window.innerHeight;

			document.querySelectorAll('.mm-main-product-media-zoomed').forEach((el) => {
				el.addEventListener('mousemove', (e) => {
					if (zoomedDiv.style.display !== 'block') return;
					mouse.x = e.x - el.offsetLeft;
					mouse.y = e.y - el.getBoundingClientRect().top;
				});
			});

			gsap.ticker.add(() => {
				if (zoomedDiv.style.display !== 'block') return;
				const dt = 1.0 - Math.pow(1.0 - 0.2, gsap.ticker.deltaRatio());
				const destX = ((thumbWidth - document.querySelector('.mm-main-product-media-zoomed img').clientWidth) * mouse.x) / thumbWidth;
				const destY = ((thumbHeight - document.querySelector('.mm-main-product-media-zoomed img').clientHeight) * mouse.y) / thumbHeight;
				pos.x += (destX - pos.x) * dt;
				pos.y += (destY - pos.y) * dt;
				gsap.set('.mm-main-product-media-zoomed img', { x: pos.x, y: pos.y });
			});
		}
	});
}

// Image du zoom
document.addEventListener('DOMContentLoaded', function () {
	const imagesZoom = document.querySelectorAll('.mm-main-product-media-elem');
	const zoomedDiv = document.getElementById('mmZoomedDivImg');

	const observer = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Ajoute mm-active-image quand l'image est visible
					entry.target.classList.add('mm-active-image');

					// Récup l'URL de l'image et ajout de style
					const imageUrl = entry.target.getAttribute('src');
					const zoomedImage = document.createElement('img');
					zoomedImage.src = imageUrl;
					zoomedImage.style.width = '100%';
					zoomedImage.style.height = 'auto';

					// Ajout de l'image à zoomedDiv
					zoomedDiv.innerHTML = '';
					zoomedDiv.appendChild(zoomedImage);
				} else {
					// Enleve mm-active-image quand l'image n'est plus visible
					entry.target.classList.remove('mm-active-image');
				}
			});
		},
		{
			threshold: 0.5, // 50% de l'image pour déclencher l'observation
		}
	);

	imagesZoom.forEach((image) => {
		observer.observe(image);
	});
});


// KLAVIYO
document.addEventListener("DOMContentLoaded", function () {
    var ticking = false;
    
    // Définir synchronizePositions en dehors de la condition
    function synchronizePositions() {
        // Ne rien faire si on n'est pas en mode desktop
        if (window.innerWidth <= 992) return;

        var element = document.querySelector(".mm-product-form-component-CTA");
        var productWrapper = document.querySelector(".mm-product-form-container");
        var iframeElement = document.getElementById("klaviyo-bis-iframe");

        if (!element || !productWrapper || !iframeElement) {
            return;
        }

        var rect = element.getBoundingClientRect();
        var topPosition = rect.top + window.scrollY;
        var productWrapperWidth = productWrapper.getBoundingClientRect().width;

        iframeElement.style.position = "absolute";
        iframeElement.style.top = topPosition + "px";
        iframeElement.style.width = "100%";
        iframeElement.style.height = "fit-content";
    
        // Charger immédiatement la largeur du container dans l'iframe
        var iframeDocument = iframeElement.contentWindow.document;
        iframeElement.onload = function () {
            var containerElement = iframeDocument.getElementById("container");

            if (containerElement) {
                containerElement.style.width = productWrapperWidth + "px";
            } else {
                console.log("Élément #container non trouvé dans l'iframe.");
            }
        };

        if (iframeElement.contentWindow.document.readyState === 'complete') {
            iframeElement.onload();
        }
    }

    // Observer pour détecter quand l'iframe est ajouté au DOM
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.id === 'klaviyo-bis-iframe') {
                    synchronizePositions();
                    setTimeout(synchronizePositions, 100);
                }
            });
        });
    });

    // Observer le document pour détecter l'ajout de l'iframe
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // ... rest of the Klaviyo code ...
});



// SELECTEUR DE QUANTITE
function changeQuantity(amount) {
    const quantityInputs = document.querySelectorAll('.quantity__input');
    const minusButtons = document.querySelectorAll('.quantity__button[name="minus"]');
    const priceElements = document.querySelectorAll('.product-price');
    const priceDividedBy3Elements = document.querySelectorAll('.price-divided-by-3');

    const currentQuantity = parseInt(quantityInputs[0].value);
    const maxQuantity = parseInt(quantityInputs[0].getAttribute('data-max-quantity')); // Stock max
    const newQuantity = currentQuantity + amount;

    if (newQuantity >= 1 && newQuantity <= maxQuantity) {
        // Mise à jour de la quantité
        quantityInputs.forEach(input => input.value = newQuantity);

        // Affichage/Masquage du bouton "moins"
        minusButtons.forEach(button => {
            if (newQuantity > 1) {
                button.classList.remove('hidden');
            } else {
                button.classList.add('hidden');
            }
        });

        // Formatage du prix
        const formatter = new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        priceElements.forEach(priceElement => {
            const unitPrice = parseFloat(priceElement.getAttribute('data-unit-price').replace(',', '.'));
            priceElement.textContent = formatter.format(unitPrice * newQuantity);
        });

        // Mise à jour du prix divisé par 3
        priceDividedBy3Elements.forEach(priceDividedBy3Element => {
            const unitPrice = parseFloat(priceDividedBy3Element.getAttribute('data-unit-price').replace(',', '.'));
            priceDividedBy3Element.textContent = formatter.format((unitPrice * newQuantity) / 3);
        });
    }
}



function getProductQtty() {
    return parseInt(document.querySelector('.quantity__input').value);
}


// FAKE BOUTONS QUI OUVRENT LES SELECTEURS
let activeSelector = null;

function toggleMobileSelector(type) {
    const selectors = {
        color: '.mm-mpf-CTA-mobile-color-container',
        size: '.mm-mpf-CTA-mobile-size-selector-container'
    };
    const header = document.querySelector('.mm-mpf-CTA-mobile-header');

    if (activeSelector === type) {
        closeMobileSelector();
    } else {
        openMobileSelector(selectors[type], selectors, type);
        activeSelector = type;
    }
}

// Vérifie si un variant est présent dans l'URL
function isVariantInURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('variant');
}

// Ouverture des selecteurs de variant
function openMobileSelector(selectorToOpen, selectors, type) {
    const selectorElement = document.querySelector(selectorToOpen);
    if (selectorElement) {
        selectorElement.style.display = 'flex';
    }

    const mobileHeader = document.querySelector('.mm-mpf-CTA-mobile-header');
    if (mobileHeader) {
        mobileHeader.style.display = 'none';
    }
    
    // Ferme les autres sélecteurs
    for (let key in selectors) {
        const element = document.querySelector(selectors[key]);
        if (element && selectors[key] !== selectorToOpen) {
            element.style.display = 'none';
        }
    }
    
    // Cache le mannequin si le sélecteur de taille est ouvert
    const mannequin = document.querySelector('.mm-main-product-media-mannequin');
    if (mannequin) {
        mannequin.style.display = (type === 'size') ? 'none' : 'flex';
    }

	// Cache la pills si le sélecteur de taille est ouvert
	const pills = document.querySelector('.mm-product-form-encart-mobile');
	if (pills) {
		pills.style.display = (type === 'size') ? 'none' : 'flex';
	}

    // Affiche le 'selectionner une taille' si le sélecteur de taille est ouvert
    const selectSizeTitle = document.querySelector('.mm-mpf-CTA-mobile-selector-size_select-size');
    const sizeTitle = document.querySelector('.mm-mpf-CTA-mobile-selector-size_size');

    if (sizeTitle) {
        sizeTitle.style.display = (type === 'size') ? 'none' : 'flex';
    }

    if (selectSizeTitle) {
        selectSizeTitle.style.display = (type === 'size') ? 'flex' : 'none';
    }

    // Cache les sélecteurs de variantes factices
    const fakeVariantSelectors = document.querySelectorAll('.mm-fake-variant-selector');
    fakeVariantSelectors.forEach(selector => {
        selector.style.display = 'none';
    });

    // Cache les .mm-fake-dcb si un variant est dans l'URL
    if (isVariantInURL()) {
        const fakeDcbElements = document.querySelectorAll('.mm-fake-dcb');
        fakeDcbElements.forEach(element => {
            element.style.display = 'none';
        });
    }
}


function showFakeVariant() {
	const fakeVariantSelectors = document.querySelectorAll('.mm-fake-variant-selector');
    fakeVariantSelectors.forEach(selector => {
        selector.style.display = 'flex';
    });
}

// Enleve les fakes CTA Button quand un produit est ajouté au panier
function hideFakeButtons() {
	const fakeCTAButtons = document.querySelectorAll('.mm-fake-dcb');
    fakeCTAButtons.forEach(fakeCTAButton => {
        fakeCTAButton.style.display = 'none';
    });
}


function closeMobileSelector() {
    const selectors = [
        '.mm-mpf-CTA-mobile-color-container',
        '.mm-mpf-CTA-mobile-size-selector-container'
    ];

	selectors.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            element.style.display = 'none';
        } else {
            console.warn(`Élément non trouvé : ${selector}`);
        }
    });

    document.querySelector('.mm-mpf-CTA-mobile-header').style.display = 'flex';

	const mannequin = document.querySelector('.mm-main-product-media-mannequin');
	if (mannequin) {
		mannequin.style.display = 'flex';
	}

	const pills = document.querySelector('.mm-product-form-encart-mobile');
	if (pills) {
		pills.style.display = 'flex';
	}

	const selectSizeTitle = document.querySelector('.mm-mpf-CTA-mobile-selector-size_select-size');
	const sizeTitle = document.querySelector('.mm-mpf-CTA-mobile-selector-size_size');

	if (sizeTitle) {
		sizeTitle.style.display = 'flex';
		selectSizeTitle.style.display = 'none';
	}

	const fakeAddToCart = document.querySelector('.mm-fake-dcb-add-to-cart');
	const fakeSizeVariant = document.querySelectorAll('.mm-fake-variant-selector');
	
	if (fakeAddToCart) {
		fakeSizeVariant.forEach(variant => {
			variant.style.display = 'none';
		});
	}

	const fakeVariantSelectors = document.querySelectorAll('.mm-fake-variant-selector');
    fakeVariantSelectors.forEach(selector => {
        selector.style.display = 'none';
    });

	if (isVariantInURL()) {
        const fakeDcbElements = document.querySelectorAll('.mm-fake-dcb');
        fakeDcbElements.forEach(element => {
            element.style.display = 'none';
        });
    }
	
    activeSelector = null;
} 

// Faire disparaitre le sticky CTA mobile quand on arrive au footer
document.addEventListener("DOMContentLoaded", () => {
    const cta = document.querySelector('.mm-main-product-form-CTA-mobile');
    const footer = document.querySelector('.mm-section-footer');

    const mediaQuery = window.matchMedia('(max-width: 992px)');

    const handleObserver = () => {
        if (mediaQuery.matches) {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        cta.style.display = 'none';
                    } else {
                        cta.style.display = 'block';
                    }
                });
            }, {
                root: null, 
                threshold: 0 
            });

            if (footer) {
                observer.observe(footer);
            }
        } else {
            if (cta) {
                cta.style.display = '';
            }
        }
    };

    // Exécute la logique au chargement
    handleObserver();

    // Écoute les changements de largeur d'écran
    mediaQuery.addEventListener('change', handleObserver);
});

// Ajuste la taille du média en mobile en fonction du sticky CTA
function adjustMediaHeight() {
    if (window.matchMedia('(max-width: 992px)').matches) {
        const productMedias = document.querySelector('.mm-product-medias');
        const ctaMobile = document.querySelector('.mm-main-product-form-CTA-mobile');

        if (productMedias && ctaMobile) {
            const ctaHeight = ctaMobile.offsetHeight;
            productMedias.style.height = `calc(100dvh - ${ctaHeight}px)`;
        }
    }
}

// Exécuter uniquement en mode mobile/tablette
window.addEventListener('load', adjustMediaHeight);
window.addEventListener('resize', adjustMediaHeight);

// Ajouter la gestion du clic sur le guide des tailles
// document.addEventListener('DOMContentLoaded', function() {
//   const sizeGuideLinks = document.querySelectorAll('.mm-product-form-size-guide-ancre');
//   const sizeDropdowns = document.querySelectorAll('.mm-product-form-description-dropdown-6');

//   sizeGuideLinks.forEach(link => {
//     link.addEventListener('click', function(e) {
//       e.preventDefault();
//       console.log('Click detected');
      
//       sizeDropdowns.forEach(dropdown => {
//         if (dropdown) {
//           dropdown.classList.add('active');
//           const container = dropdown.nextElementSibling;
//           if (container) {
//             container.style.maxHeight = 'none'; // Supprime la limite de hauteur
//           }
//           console.log('sizeDropdown', dropdown);
//           console.log('Added active class');
          
//           // Scroll jusqu'au dropdown avec un offset de 100px depuis le haut
//           const yOffset = -100; 
//           const y = dropdown.getBoundingClientRect().top + window.pageYOffset + yOffset;
          
//           window.scrollTo({
//             top: y,
//             behavior: 'smooth'
//           });
//         }
//       });
//     });
//   });
// });



